import type { RunStatus } from "@models/review";

/**
 * Why Publish is locked for the open run, or `null` when it may be pressed.
 *
 * D20 (contract VERSION 36): Publish needs the run in `GENERATED` and nothing
 * pending. A run with zero reviewable images, or only failed images, is still
 * publishable, so `anyPending` is the only review-side blocker. The server is
 * the authority; this only decides what the button says and whether it is
 * enabled.
 */
export type PublishBlocker = "returning" | "published" | "notGenerated" | "pending";

export function getPublishBlocker(
  runStatus: RunStatus | null,
  anyPending: boolean,
): PublishBlocker | null {
  if (runStatus === "PUBLISHING") return "returning";
  if (runStatus === "COMPLETED") return "published";
  if (runStatus !== "GENERATED") return "notGenerated";
  if (anyPending) return "pending";
  return null;
}

/** The i18n key that explains a blocker to the user. */
export const PUBLISH_BLOCKER_KEY: Record<PublishBlocker, string> = {
  returning: "review.publish.returningTitle",
  published: "review.publish.alreadyPublished",
  notGenerated: "review.publish.notGenerated",
  pending: "review.publish.lockedPending",
};
